import request from '@/plugins/axios'
import configs from '@/config'

/** 与 axios 头里的 version 一致；部分平台接口会校验 query/body 中的 version */
function withVersion<T extends Record<string, unknown>> (payload: T): T & { version: string } {
  return { ...payload, version: configs.version }
}

// 汇总统计（近7天/近30天）
export const apiFinanceSummary = (params: { period: 'week' | 'month' }) =>
  request.get('/work_order.workOrderFinance/summary', { params: withVersion({ ...params }) })

// 趋势列表（近7天/近30天），返回按 date 升序的数组
export const apiFinanceTrend = (params: { period: 'week' | 'month' }) =>
  request.get('/work_order.workOrderFinance/trend', { params: withVersion({ ...params }) })

// 手动重新统计某天数据
export const apiFinanceRegenerate = (data: { date: number }) =>
  request.post('/work_order.workOrderFinance/regenerate', withVersion({ ...data }))
